import { CustomModalLayout, Modal } from '@wix/design-system';
import React, { FC } from 'react';

import { SiteList, SiteListProps } from './SiteList';

import s from './index.module.scss';

export type SiteSelectorModalProps = Omit<SiteListProps, 'isModalOpen'> & {
  isOpen: boolean;
  onClose: () => void;
};

export const SiteSelectorModal: FC<SiteSelectorModalProps> = ({
  isOpen,
  onClose,
  ...listProps
}) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={onClose}
    shouldCloseOnOverlayClick
    zIndex={1000000}
  >
    <div className={s.siteSelectorModal}>
      <CustomModalLayout
        className={s.modalLayout}
        closeButtonProps={{ onClick: onClose, size: 'medium', skin: 'standard' }}
        showHeaderDivider={false}
        showFooterDivider={false}
        removeContentPadding={true}
        content={
          <SiteList {...listProps} isModalOpen={isOpen} onClose={onClose} />
        }
      />
    </div>
  </Modal>
);
